import SaveErrorDialog from '../../../components/SaveErrorDialog';
import { FlowSaveError } from '../Models/FlowSaveError';

interface FlowSaveErrorDialogProps {
	error?: FlowSaveError;
	onClose: () => void;
}

export default function FlowSaveErrorDialog({ error, onClose }: FlowSaveErrorDialogProps) {
	return <SaveErrorDialog error={error} onClose={onClose} settingsKey="flowSaveErrorDialog.maximized" />;
}
